module.exports = "/_next/static/images/fingerPrint-f8553a8fd852497a9b99d371a03a1d34.png";